module.exports = __webpack_public_path__ + "img/photo04_pc.63d2c943.jpg";